import React from "react";
import circle from "../../assets/signIn.svg";
import { LeftExplanation } from "../../molecules/LeftExplanation";

function InfluencerLoginExplanation() {
  const explanation =
    "To partner with opportunities on Video Squirrel, " +
    "create videos, and make sales, please sign in.";
  return (
    <LeftExplanation
      icon={circle}
      title="Sign in to Your Video Squirrel Account"
      explanation={explanation}
      titleColor={true}
    />
  );
}

export default InfluencerLoginExplanation;
